var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatorButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.263,
    height: 49.264,
    viewBox: "0 0 49.263 49.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Creator_button",
    "data-name": "Creator button",
    transform: "translate(3617.005 -2217.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M74.631,189.264a24.632,24.632,0,1,1,24.631-24.632A24.659,24.659,0,0,1,74.631,189.264Z",
    transform: "translate(-3667.005 2077.972)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(-3604.195 2230.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M200.166,382.956H179.478a1.478,1.478,0,1,1,0-2.956h20.688a1.478,1.478,0,1,1,0,2.956Zm0,0",
    transform: "translate(-178 -369.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M291.478,291.644A1.478,1.478,0,0,1,290,290.166V269.478a1.478,1.478,0,0,1,2.955,0v20.688a1.478,1.478,0,0,1-1.478,1.478Zm0,0",
    transform: "translate(-279.656 -268)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorButton);
export default __webpack_public_path__ + "static/media/creator-button.e7757eae7004f446bf6b616452d04308.svg";
export { ForwardRef as ReactComponent };